// extracted by mini-css-extract-plugin
export default {"splash":"StyledContent-module--splash--1727a"};